import type React from 'react';

import { CopyButton, Toaster } from '@change/ds-core-ui';

import { getWindow } from '@change-corgi/core/window';
import { useI18n } from '@change-corgi/core-react/i18n';
import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { copyToClipboard } from '#src/app/shared/utils/clipboard';

export const CopylinkButton: React.FC = () => {
	const { i18n } = useUtilityContext();
	const { translate } = useI18n();

	return (
		<>
			<Toaster />
			<CopyButton
				buttonLabel={translate(
					'corgi.petition_actions.supporter_voice_video.record.unsupported_browser.copy_button.label',
				)}
				toastSuccessLabel={translate('corgi.petition.starter_dashboard.grow_petition.copy_link.copy_success')}
				toastErrorLabel={translate(
					'corgi.petition_actions.supporter_voice_video.record.unsupported_browser.copy_button.error',
				)}
				onClick={async () => copyToClipboard(getWindow().location.href, i18n)}
				variant="secondary"
				data-testid="copy-link-button"
				data-qa="copy-link-button"
			/>
		</>
	);
};
